import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-email-options',
    templateUrl: './email-options.component.html',
})
export class EmailOptionsComponent implements OnInit {

    constructor(private _bc: BreadcrumbsService) {
    }

    ngOnInit() {
        this._bc.start('Email');
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-options/email-options.component.ts